import ProcessMap from './processMap';

export default ProcessMap;
